import React from 'react'
import { t } from 'i18next'
import { Field } from './Field'
import { Dropdown, Option } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { Workplace } from '../../../api/schemas/schema'
import { ConditionalTooltip } from '../other/ConditionalTooltip'

type ControlledWorkplaceDropdownProps = {
   name: any
   control: Control<any>
   label: string
   options: Workplace[]
   showTooltip?: boolean
   tooltipMsg?: string
   disabled?: boolean
   required?: boolean
}

export const ControlledWorkplaceDropdown = ({
   name,
   control,
   label,
   options,
   showTooltip,
   tooltipMsg,
   disabled,
   required,
}: ControlledWorkplaceDropdownProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('RequiredField') : false }}
         render={({ field: { value, onChange }, fieldState: { error } }) => {
            return (
               <Field label={label} required={required ?? false} validationMessage={error?.message ?? null} validationState={error ? 'error' : null}>
                  <ConditionalTooltip show={showTooltip} content={tooltipMsg}>
                     <Dropdown
                        disabled={disabled ?? false}
                        selectedOptions={value ? [value.id] : []}
                        value={value ? value.name : ''}
                        onOptionSelect={(e, d) => {
                           const selected = options.find((opt) => opt.id === d.optionValue)
                           if (selected) onChange(selected)
                        }}
                     >
                        {options.map((wp) => (
                           <Option key={wp.id} value={wp.id}>
                              {wp.name}
                           </Option>
                        ))}
                     </Dropdown>
                  </ConditionalTooltip>
               </Field>
            )
         }}
      />
   )
}
